<ng-container *transloco="let t">
  <ld-base-modal
    [title]="t('modalsMissingInformationTitle')"
    [showCloseButton]="false"
    (closeModal)="closeAction.emit()"
  >
    <div modal-content>
      <div class="space-y-4 text-ld-neutral-600">
        <p id="missing-information-modal-description-1">
          Oops, it looks like you skipped some required fields when going through the loan application.
        </p>
        <p id="missing-information-modal-description-2">
          To provide you with an accurate mortgage offer, select
          <span class="font-semibold">'Continue'</span>
          below and follow screens to provide needed information.
        </p>
        <p id="missing-information-modal-description-3" class="text-sm text-ld-neutral-500">
          If you select
          <span class="font-semibold">'Submit'</span>
          then you will be able to submit an application, but will not be presented with an offer.
        </p>
      </div>
    </div>
    <div modal-footer>
      <button
        id="missing-information-modal-submit-button"
        type="button"
        class="btn-outline-ld-purple flex-1"
        [disabled]="isLoading()"
        (click)="onSubmit()"
      >
        {{ t('modalsMissingInformationSubmitWithoutOffer') }}
      </button>
      <button
        id="missing-information-modal-continue-button"
        type="button"
        class="btn-primary-ld-purple flex-1"
        [disabled]="isLoading()"
        (click)="onContinue()"
      >
        @if (isLoading()) {
          <mat-spinner diameter="16" class="!w-4 !h-4 [&_circle]:!stroke-white"></mat-spinner>
        }
        {{ t('commonButtonsContinue') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
